<template>
  <div
    :id="`${id}`"
    :class="{
      'card-content': true,
      'collapsecontainer': true,
      'collapsecontainer--open': !collapsed
    }">
    <div
      ref="cardInner"
      class="card-inner">
      <button
        :id="`${id}_image`"
        class="card-inner__image-container"
        v-if="commentImage"
        @click="onImageClick()">
        <img
          :alt="commentDesc"
          class="image"
          :src="imagePath + commentImage" />
      </button>
      <div
        class="card-inner__info"
        @click="onInfoClick($event)">
        <h2
          :id="`${id}_title`"
          v-if="commentTitle !== ''">
          <span>{{ commentTitle }}</span>
        </h2>
        <div
          :id="`${id}_comment`"
          class="card-inner__description"
          v-html="commentText"></div>
        <div
          :id="`${id}_count`"
          class="card-inner__count"
          v-if="commentCount !== ''">
          {{ commentCount }}
          <button
            class="cardcollapseicon"
            :aria-expanded="!collapsed"
            aria-label="More location details">
            <span
              :class="{
                'ui-icon': true,
                'state-collapsed': collapsed,
                'state-expanded': !collapsed
              }"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommentCardComponent',
  props: {
    id: String,
    commentImage: String,
    commentTitle: String,
    commentText: String,
    commentCount: String,
    commentDesc: String
  },
  data() {
    return {
      imagePath: App.settings.ImagePath,
      collapsed: true
    }
  },
  created() {},
  methods: {
    onInfoClick(event) {
      if (event.target.tagName.toLowerCase() === 'a') {
        return
      }

      event.preventDefault()
      event.stopPropagation()
      this.collapsed = !this.collapsed
    },
    onImageClick() {
      const URL =
        this.commentImage != null ? this.imagePath + this.commentImage : null
      const title = this.commentDesc

      if (URL) {
        // Add resize event in case screen size changes
        if (!this.__resizeEvent) {
          $(window).on('resize', function () {
            let $dialog = $('#imagedialog')
            if ($dialog.length > 0) {
              $dialog.dialog('option', {
                width:
                  $(window).width() > 1000 ? 1000 : $(window).width() * 0.9,
                maxWidth: $(window).width() * 0.9
              })
            }
          })
        }

        const $imageDialog = $(
          '<div id="imagedialog">' +
            '<img class="imagedialog-image" src="' +
            URL +
            '" >' +
            '</div>'
        ).appendTo($('body'))

        $imageDialog.dialog({
          title: title,
          resizable: false,
          draggable: false,
          modal: true,
          width: $(window).width() > 830 ? 830 : $(window).width() * 0.9,
          maxWidth: $(window).width() * 0.9,
          height: 800,
          close: function () {
            $(this).dialog('destroy').remove()
          }
        })

        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/abstract/variables';
@import '../assets/css/abstract/mixins';

.card-content {
  margin-top: 16px;
  margin-bottom: 16px;
  border: 1px solid rgba(192, 192, 192, 0.5);
  border-radius: 2px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #f2f2f2;
  box-sizing: border-box;

  &:hover {
    background-color: #eaeaea;
  }

  .card-inner {
    display: flex;
    margin: 0;
    padding: 0;
    border-style: none;
    border-radius: 0;
    background-image: none;
    text-indent: 0;
    line-height: 1rem;

    .cardcollapseicon {
      .default-focus-indicator(0, black);
      display: inline-block;
      margin-left: 2px;
      width: 24px;
      height: 24px;
      border-radius: 4px;

      .ui-icon {
        width: 100%;
        height: 100%;
        cursor: pointer;
        background-position: center;
        background-repeat: no-repeat;

        &.state-collapsed {
          background-image: url('../assets/img/icons/glyph/16/small-triangle-down.svg');
          margin-top: 0;
        }

        &.state-expanded {
          background-image: url('../assets/img/icons/glyph/16/small-triangle-up.svg');
        }
      }
    }

    h2 {
      font-size: @font-size-16px;
      line-height: 2rem;
      margin: 0;
      font-weight: 600;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }

    &__info {
      width: 100%;
      padding: 6px 20px;
      margin-left: 2px;
    }

    &__description {
      padding: 0;
      line-height: 1.7;
      font-size: @font-size-12px;
    }

    &__image-container {
      .default-focus-indicator(0, black);
      position: relative;
      left: 2px;
      top: 2px;
      height: 110px;
      width: 200px;
      flex-shrink: 0;
    }

    &__count {
      font-size: 0.875rem;
      font-weight: bold;
      line-height: 1.6rem;
    }
  }
}

.card-content.collapsecontainer {
  max-height: 120px;
  overflow: hidden;
  cursor: pointer;

  .card-inner__description {
    /* Add ellipsis to the description */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 2.8rem;
    overflow: hidden;
  }

  &--open {
    max-height: unset;
    cursor: default;

    .card-inner__description {
      display: block;
      height: auto;
    }
  }
}

@media @tablet-down {
  .collapsecontainer--open {
    .card-inner {
      flex-direction: column;

      &__image-container {
        width: 100%;
        height: auto;
        padding-top: 60%;
      }
    }
  }
}
</style>
